import React from "react"
import { ISearchValue, SearchTypeEnum } from "../../../../components2/YhPageHeader/Types";
import { YhPageHeader } from "../../../../components2/YhPageHeader";
import { useUserModel } from "../userModel"
import useMdmModel from "../../../../model/mdmModel"

export function SearchForm() {
    const {
        searchParam,
        upDataSearchParam,
        resetSearchParam,
        loadData
    } = useUserModel();
    const {mdmCatalog,mdmBranch,mdmSourceApp} = useMdmModel();
    const searchFields = [
        {
            type: SearchTypeEnum.Select,
            span: 4,
            placeholder: "分支编码",
            fieldName: "branch",
            size: "small",
            disabled: false,
            options: mdmBranch
        },
        {
            type: SearchTypeEnum.Input,
            span: 4,
            placeholder: "用户编码",
            fieldName: "code",
            size: "small",
            disabled: false,
        },
        {
            type: SearchTypeEnum.Input,
            span: 4,
            placeholder: "用户名称",
            fieldName: "name",
            size: "small",
            disabled: false,
        },
        {
            type: SearchTypeEnum.Select,
            span: 4,
            placeholder: "状态",
            fieldName: "enable",
            size: "small",
            disabled: false,
            options:[{key:"0",label:"关闭",value:"0"},{key:"1",label:"开启",value:"1"}]
        }
    ]
    return (
        <YhPageHeader
            title="用户管理列表"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={upDataSearchParam}
            handleSearch={loadData}
            handleReset={resetSearchParam}
        />
    )
}